import React from "react";
import { Card, Box, Typography, SvgIcon, useTheme, useMediaQuery } from "@mui/material";
import { getNumberUnits } from "../../helper/service";
import { useAppSelector } from "../../store/store";
import { convertTemperatureToCelsius } from "../../config/util";
import DeviceInfoTooltip from "../common/DeviceInfoTooltip";

// Define types
interface Metric {
  label: string;
  displayName: string;
  substanceKey: string;
  value: number;
  value1: number;
  count: string;
  unit?: string;
  color: string;
  isoIndex: string;
  icon?: string;
  providers?: any;
}
interface MetricsSectionProps {
  summaryPage: (data: Metric) => void
  metric: Metric;
}
const MetricCard: React.FC<MetricsSectionProps> = ({ summaryPage, metric }) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { value, value1, count, icon, isoIndex, substanceKey, displayName, unit, color, providers } = metric;
  const userData = useAppSelector((store) => store?.authReducer?.userData);
  let twoPlacedFloat: any =
    value != null
      ? Number.isInteger(value)
        ? value
        : value.toFixed(2)
      : "--";
  twoPlacedFloat =
    twoPlacedFloat != "--"
      ? getNumberUnits(twoPlacedFloat, substanceKey, unit)
      : "--";
  let twoPlacedFloat1 =
    value1 != null
      ? Number.isInteger(value1)
        ? value1
        : value1.toFixed(2)
      : "--";
  twoPlacedFloat1 =
    twoPlacedFloat1 != "--"
      ? getNumberUnits(twoPlacedFloat1, substanceKey, unit)
      : "--";
  return (
    <Card
      sx={{
        display: "flex",
        alignItems: "center",
        p: 1.5,
        borderRadius: 2,
        // boxShadow: 1,
        bgcolor: "#fff",
        minWidth: 120,
        flex: "1 1 auto",
        justifyContent: "space-between",
        maxWidth: 225,
        cursor: "pointer",
        position: "relative"
      }}
      onClick={() => summaryPage(metric)}
    >
      {/* <Box sx={{ position: "absolute", right: 0, top: 0.5 }} >
        <DeviceInfoTooltip providers={providers} fontsize={15} />
      </Box> */}
      <Box
        sx={{
          bgcolor: color,
          p: 1,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 1.5,
          width: "35px",
          height: "35px"
        }}
      >
        <img src={`/assets/images/${icon}.svg`} style={(color == "#871014" || color == "#000000") ? { "filter": "brightness(0) invert(1)" } : { "filter": "brightness(1) invert(0)" }} />
      </Box>
      <Box
        sx={{
          display: isMobile ? "flow" : "flex",
          alignItems: "center",
          gap: 0.5,
          whiteSpace: "nowrap",
          flexWrap: "wrap",  // Allows content to wrap if needed
          overflow: "hidden", // Prevents content overflow
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 600, textTransform: "uppercase" }}>
          {displayName} {isMobile ? "" : "|"}
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          {(() => {
            if (substanceKey === "thir") return `${twoPlacedFloat1} ${unit}`;
            else if (substanceKey === "isopm10psd")
              return isoIndex || "-";
            else if (substanceKey === "temperature")
              return (userData?.temperature_unit === "C" && parseFloat(twoPlacedFloat))
                ? convertTemperatureToCelsius(twoPlacedFloat)?.value
                : `${twoPlacedFloat} ${unit} `;
            return `${twoPlacedFloat} ${unit}`
          })()}
        </Typography>
      </Box>
    </Card>
  );
};

export default MetricCard;
